import React from 'react';
import Category from '../components/categoryButtons/category';
import MovieList from '../components/movielist/movielist';
import Slider from '../components/slider/slider'

const Homepage = () => {
    return (
        <div>
            <Slider />
            <Category />
        </div>
    );
};

export default Homepage;